<template>
    <div class="login-form" @keyup.enter="login()">
        <h2>Login</h2>
        <input type="text" placeholder="Email" v-model="user.email">
        <input type="password" placeholder="Password" v-model="user.password">
        <Button @click="login()">Login</Button>
        <div>- or -</div>
        <router-link to="/signup">Sign Up</router-link>
    </div>
</template>

<script>
    import Button from '../components/Button';

    export default {
        methods: {
            login() {
                const that = this;
                this.$store.dispatch('session/login', this.user)
                    .then(() => {
                        if (that.$route.query.redirect) {
                            that.$router.push({path: this.$route.query.redirect });
                        } else {
                            that.$router.push({name: 'MyClaims' });
                        }
                    });
            }
        },
        data() {
            return {
                user: {}
            };
        },
        // watch: {
        //     loggedIn() {
        //         const session = this.$store.getters['session/getCurrent'];
        //         if (session) {
        //             if (this.$route.params.redirect) {
        //                 this.$router.push({path: this.$route.params.redirect });
        //             } else {
        //                 this.$router.push({name: 'MyClaims' });
        //             }
        //         }
        //         return false;
        //     }
        // },
        components: {
            Button
        }
    }
</script>

<style lang="scss">
    .login-form {
        * {
            display: block;
            margin: auto;
            margin-bottom: $space-32;

            width: $space-256;
        }

        *:last-child {
            margin-bottom: 0;
        }
    }
</style>